export enum CrossSalesProduct {
    GTM_SERVER_SIDE = "GTM_SERVER_SIDE",
    TAG_CONDITIONING = "TAG_CONDITIONING",
    COMPLIANCE_AUDIT = "COMPLIANCE_AUDIT"
}
